import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { RedirectService } from "src/app/core";
import { PartnerShowroom } from "src/app/features/partner-portal/models/partner-showroom";
import { PartnerPortalShowroomEventLoaderService, PartnerPortalShowroomsService } from "src/app/features/partner-portal/services";
import { SHOWROOM_GUEST_LINK_ARCHIVED_TOOLTIP } from "src/app/features/partner-portal/utils/partner-portal-events-ui-helper";
import { ShowroomService } from "../../../services";

@Component({
  selector: "app-showroom-preview-button",
  templateUrl: "./showroom-preview-button.component.html",
  styleUrls: ["./showroom-preview-button.component.scss"],
  standalone: false,
})
export class ShowroomPreviewButtonComponent implements OnInit, OnDestroy {
  private _destroyed$: Subject<void> = new Subject<void>();

  SHOWROOM_GUEST_LINK_ARCHIVED_TOOLTIP = SHOWROOM_GUEST_LINK_ARCHIVED_TOOLTIP;

  showroom: PartnerShowroom;

  constructor(
    private _partnerPortalShowroomEventLoaderService: PartnerPortalShowroomEventLoaderService,
    private _partnerPortalShowroomsService: PartnerPortalShowroomsService,
    private _redirectService: RedirectService,
    private _showroomService: ShowroomService,
  ) {}

  ngOnInit(): void {
    this._partnerPortalShowroomsService.showrooms$.pipe(takeUntil(this._destroyed$)).subscribe({
      next: showrooms => {
        this.showroom = showrooms?.find(showroom => showroom.eventId === this._partnerPortalShowroomEventLoaderService.getLoadedEventId());
      },
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  onPreviewShowroomClick(): void {
    if (!this.showroom || this.showroom.archived) {
      return;
    }

    this._redirectService.redirectExternal(this._showroomService.getShowroomPublicPageUrl(this.showroom.accessCode), "_blank");
  }
}
